export class DocumentDetails {
    file: any;
    documentType: string;
}